import React from 'react';
import { Button } from 'semantic-ui-react';
import { shape, arrayOf, string } from 'prop-types';

const BackButton = ({ history, terms }) => (
  <Button
    icon="left arrow"
    content={terms[1]}
    onClick={() => history.goBack()}
  />
);

BackButton.propTypes = {
  history: shape().isRequired,
  terms: arrayOf(string).isRequired,
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/BackButton.jsx